<template>
    <div class="cookies-popup" v-if="is_open">
        <div class="page-inner">
            <div class="box">
                <div class="text" v-html="$store.state.cookies.text"></div>
                <div class="link-btn" v-if="$store.state.cookies.button_text && $store.state.cookies.button_link"><Link @click.native="close" :post_link="$store.state.cookies.button_link">{{$store.state.cookies.button_text}}</Link></div>
                <div class="close-btn"><span @click="close">Accept</span></div>
            </div>
        </div>
    </div>
</template>

<script>
import Link from '@/components/ui/Link.vue';

export default {
    name: 'cookies',
    components: {
        Link,
    },
    data() {
        return {
            is_open: true,
        }
    },
    methods: {
        close() {
            window.localStorage.setItem('hide_cookies', 1);
            this.is_open = false;
        },
    },

}
</script>

<style lang="scss">

    .fade-enter-active, .fade-leave-active {
        opacity: 1;
        transition: opacity .3s ease-in-out;
    }

    .fade-enter, .fade-leave-to {
        opacity: 0;
    }

    .cookies-popup {
        position: fixed;
        bottom: 0;
        left: 0;
        z-index: 999;
        padding: var(--padding-25) var(--padding);
        background: var(--cloud-blue);
        box-sizing: border-box;
        width: 100%;
        color: black;
        font-size: var(--large-size);

        .box {
            display: flex;

            .link-btn {
                padding: 0 var(--padding-50);
            }

            .close-btn {
                flex: 1;
                text-align: right;
            }
        }

        a,
        span {
            cursor: pointer;
            &:hover {
                text-decoration: underline;
            }
        }
    }

    @media only screen and (max-width: 767px) {
        .cookies-popup .box {
            display: block;
            font-size: var(--base-size);
            div {
                display: inline-block;
            }
        }
    }

</style>
